// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"bbe099a9","990":"baec7a7b"}[chunkId] + ".chunk.js";
};